module.exports = __webpack_public_path__ + "img/single_1.c680addf.png";